{
  "ecosystem": "opin",
  "generatedAt": "2026-10-01T02:49:02.831Z",
  "issues": []
}
